<template>
  <div class="snapchat parent w-100 position-relative">
    <header class="">
      <div>
        <span> Snapchat Ads </span>
      </div>
      <div>
        <img src="@/assets/snapchatImage/download.svg" alt="" />
      </div>
      <div>
        <button type="button" @click="changeOrganization">
          Change Organization
        </button>
      </div>
    </header>
    <v-container
      fluid
      style="min-height: calc(100vh - 55px); display: grid; padding: 0"
    >
      <v-row class="h-100 ma-0" style="background-color: #f9f9fa">
        <v-col cols="3" class="py-0 px-0" style="position: relative">
          <SideNav :firstTile="selectedType" />
        </v-col>
        <v-col cols="8" class="main-contain pa-8">
          <div v-if="validations.length > 0" class="validations">
            <div class="d-flex align-center ga-3 validation-message">
              <svg
                width="24"
                height="24"
                viewBox="0 0 16 16"
                fill="#444546"
                xmlns="http://www.w3.org/2000/svg"
                class="blue-warning-svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13 8C13 10.7614 10.7614 13 8 13V8V3C10.7614 3 13 5.23858 13 8ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z"
                ></path>
              </svg>
              <span
                >There Are
                {{
                  validations
                    .map((validation) => validation.data.length)
                    .reduce((a, b) => a + b, 0)
                }}
                Items To Review Before Publishing</span
              >
            </div>
            <div
              v-for="SingleValidation in validations"
              :key="SingleValidation.type"
            >
              <div
                v-for="validation in SingleValidation.data"
                :key="validation.key"
                class="d-flex align-center ga-2 validation-message"
              >
                <span class="text-capitalize key">{{ validation.key }}</span>
                <span style="max-width: 46vw">{{ validation.message }}</span>
              </div>
              <div class="d-flex justify-end review-button mt-2">
                <button
                  @click="this.$router.push({ name: SingleValidation.path })"
                >
                  Start Review
                </button>
              </div>
            </div>
          </div>
          <div class="all-contain-form">
            <v-card class="media-card" :variant="plain">
              <v-tabs v-model="tab" align-tabs="center" color="transparent">
                <v-tab
                  :value="1"
                  v-if="AllAvailableTypes.includes('Single Image or Video')"
                >
                  <div
                    class="tab-container d-flex flex-column ga-2 align-center justify-center"
                  >
                    <div class="img">
                      <img
                        :src="
                          tab === 1
                            ? require('@/assets/snapchatImage/single-image-or-video-active.svg')
                            : require('@/assets/snapchatImage/single-image-or-video-inactive.svg')
                        "
                        alt=""
                      />
                    </div>
                    <div class="name">
                      <span>Single Image or Video</span>
                    </div>
                  </div>
                </v-tab>
                <v-tab :value="2" v-if="AllAvailableTypes.includes('Story Ad')">
                  <div
                    class="tab-container d-flex flex-column ga-2 align-center justify-center"
                  >
                    <div class="img">
                      <img
                        :src="
                          tab === 2
                            ? require('@/assets/snapchatImage/story-ad-active.svg')
                            : require('@/assets/snapchatImage/story-ad-inactive.svg')
                        "
                        alt=""
                      />
                    </div>
                    <div class="name">
                      <span>Story Ad</span>
                    </div>
                  </div>
                </v-tab>
                <v-tab
                  :value="3"
                  v-if="AllAvailableTypes.includes('Collection Ad')"
                >
                  <div
                    class="tab-container d-flex flex-column ga-2 align-center justify-center"
                  >
                    <div class="img">
                      <img
                        :src="
                          tab === 3
                            ? require('@/assets/snapchatImage/collection-ad-active.svg')
                            : require('@/assets/snapchatImage/collection-ad-inactive.svg')
                        "
                        alt=""
                      />
                    </div>
                    <div class="name">
                      <span>Collection Ad</span>
                    </div>
                  </div>
                </v-tab>
                <v-tab :value="4" v-if="AllAvailableTypes.includes('AR Ads')">
                  <div
                    class="tab-container d-flex flex-column ga-2 align-center justify-center"
                  >
                    <div class="img">
                      <img
                        :src="
                          tab === 4
                            ? require('@/assets/snapchatImage/ar-ads-active.svg')
                            : require('@/assets/snapchatImage/ar-ads-inactive.svg')
                        "
                        alt=""
                      />
                    </div>
                    <div class="name">
                      <span>AR Ads</span>
                    </div>
                  </div>
                </v-tab>
              </v-tabs>
              <v-tabs-window v-model="tab">
                <v-tabs-window-item
                  v-if="AllAvailableTypes.includes('Single Image or Video')"
                  :value="1"
                >
                  <SingleImageOrVideo />
                </v-tabs-window-item>
                <v-tabs-window-item
                  v-if="AllAvailableTypes.includes('Story Ad')"
                  :value="2"
                >
                  <StoryAd />
                </v-tabs-window-item>
                <v-tabs-window-item
                  v-if="AllAvailableTypes.includes('Collection Ad')"
                  :value="3"
                >
                  <CollectionAd />
                </v-tabs-window-item>
              </v-tabs-window>
            </v-card>
          </div>
          <div class="footer d-flex align-center justify-center">
            <div
              class="d-flex align-center justify-space-between footer-contain"
            >
              <v-btn
                type="button"
                color="#444546"
                rounded
                class="footer-back-btn"
                variant="outlined"
                @click="backStep"
                >Back</v-btn
              >
              <div class="d-flex align-center">
                <p>
                  <span>
                    <svg
                      viewBox="0 0 16 16"
                      fill="#39CA8E"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      class="sds-icon sds-icon-check-circle styles-15ro776"
                    >
                      <path
                        d="M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992ZM11.1422 5.2486L6.90277 9.488L4.88826 7.47349L3.94545 8.4163L6.90277 11.3736L12.085 6.19141L11.1422 5.2486Z"
                      ></path>
                    </svg>
                  </span>
                  Draft Saved
                </p>
                <v-btn
                  type="button"
                  color="#444546"
                  rounded
                  @click="finish"
                  class="footer-next-btn"
                  variant="outlined"
                  >Publish </v-btn
                >
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="sending" width="500" persistent>
      <div
        class="w-100 d-flex flex-column justify-center align-center ga-5 pa-8 bg-white rounded-lg"
      >
        <div style="width: 250px">
          <LoadingSvg />
        </div>
        <span>Awesome! Your ads Are now publishing</span>
      </div>
    </v-dialog>
    <v-dialog v-model="store.created" width="500" persistent>
      <div
        class="w-100 d-flex flex-column justify-center align-center ga-5 pa-8 bg-white rounded-lg"
      >
        <img
          width="180px"
          :src="creativeSvg"
          alt="Awesome! Your ads Are now publishing"
        />
        <span>Success! Your ads Are now under Review</span>
        <router-link
          class="new-ads"
          @click="store.created = false"
          to="/snapchat"
          >New Ads</router-link
        >
      </div>
    </v-dialog>
  </div>
</template>
<script>
import SideNav from "@/components/snapchat/SideNav.vue";
import SingleImageOrVideo from "@/components/snapchat/media/SingleImageOrVideo.vue";
import StoryAd from "@/components/snapchat/media/StoryAd.vue";
import CollectionAd from "@/components/snapchat/media/CollectionAd.vue";

import "@/assets/snapchatStyle/snapchatStyle.css";
import { useAwarenessStore } from "@/store/snapchat/awareness";
import creativeSvg from "@/assets/snapchatImage/creating.svg";
import LoadingSvg from "@/components/snapchat/LoadingSvg.vue";

export default {
  components: {
    SideNav,
    SingleImageOrVideo,
    StoryAd,
    CollectionAd,
    LoadingSvg,
  },
  data: () => ({
    tab: 1,
    validations: [],
    sending: false,
    selectedType: localStorage.getItem("selectedOption"),
    selected_goal: localStorage.getItem("selected_goal"),
    creativeSvg,
    store: useAwarenessStore(),
  }),
  methods: {
    backStep() {
      this.$router.push({ name: "SnapSecoundStep" });
    },
    async finish() {
      this.sending = true;
      try {
        await this.store.create();
        this.validations = this.store.validationData;

        if (!this.validations || Object.keys(this.validations).length === 0) {
          const keepKeys = [
            "snapchatTokenExpireAt",
            "snapchat_token",
            "tiktokTokenExpireAt",
            "tiktok_token",
            "user",
            "user_token",
            "instagramTokenExpireAt",
            "instagram_token",
            "deviceId",
            "driveTokenExpireAt",
            "drive_token",
            "facebookTokenExpireAt",
            "facebook_token",
          ];

          const keysToRemove = [];
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (!keepKeys.includes(key)) {
              keysToRemove.push(key);
            }
          }

          keysToRemove.forEach((key) => localStorage.removeItem(key));
        }

        this.sending = false; // ✅ مهم جداً
      } catch (error) {
        this.sending = false;
        console.error("Unexpected error in finish function:", error);
      }
    },
    changeOrganization() {
      this.$router.push({ name: "SnapChat" });
    },
  },
  mounted() {
    this.validations = this.store.validationData;
  },
  watch: {
    tab() {
      if (this.tab === 1) {
        localStorage.setItem("creative_type", "Single Image or Video");
      } else if (this.tab === 2) {
        localStorage.setItem("creative_type", "Story Ad");
      } else if (this.tab === 3) {
        localStorage.setItem("creative_type", "Collection Ad");
      }
    },
  },
  computed: {
    AllAvailableTypes() {
      let objective = localStorage.getItem("selectedOption");
      let direction = localStorage.getItem("direct_traffic_location");
      let goal = localStorage.getItem("selected_goal");
      let availableTypes = [];
      console.log(objective, direction, goal);

      if (objective === "Awareness & Engagement") {
        switch (goal) {
          case "IMPRESSIONS":
            availableTypes = [
              "Single Image or Video",
              "Story Ad",
              "Collection Ad",
              "Commercial",
              "AR Ads",
            ];
            break;
          case "VIDEO_VIEWS_15_SEC":
          case "VIDEO_VIEWS":
            availableTypes = ["Single Image or Video"];
            break;
          case "SWIPES":
            availableTypes = [
              "Single Image or Video",
              "Story Ad",
              "Collection Ad",
              "AR Ads",
            ];
            break;
          case "USES":
            availableTypes = ["AR Ads"];
            break;
          case "STORY_OPENS":
            availableTypes = ["Story Ad"];
            break;
        }
      }

      if (objective === "Traffic") {
        switch (direction) {
          case "WEB":
            switch (goal) {
              case "SWIPES":
              case "LANDING_PAGE_VIEW":
                availableTypes = [
                  "Single Image or Video",
                  "Story Ad",
                  "Collection Ad",
                ];
                break;
            }
            break;
          case "APP":
            switch (goal) {
              case "APP_REENGAGE_PURCHASE":
                availableTypes = ["Single Image or Video", "Collection Ad"];
                break;
              case "LANDING_PAGE_VIEW":
                availableTypes = ["Story Ad"];
                break;
            }
            break;
          case "My Public Profile":
            switch (goal) {
              case "SWIPES":
              case "IMPRESSIONS":
                availableTypes = ["Single Image or Video", "Story Ad"];
                break;
            }
            break;
          case "CALL":
          case "TEXT":
            switch (goal) {
              case "SWIPES":
              case "IMPRESSIONS":
                availableTypes = ["Single Image or Video"];
                break;
            }
            break;
        }
      }

      if (objective === "Leads") {
        switch (goal) {
          case "SWIPES":
          case "LEAD-FORM":
            availableTypes = ["Single Image or Video"];
            break;
          case "LANDING_PAGE_VIEW":
            availableTypes = [
              "Single Image or Video",
              "Story Ad",
              "Collection Ad",
            ];
            break;
          case "LEAD_FORM_SUBMISSIONS":
            availableTypes = ["Single Image or Video", "Story Ad"];
            break;
        }
      }
      if (objective === "App Promotion") {
        let appPromotionGoal = localStorage.getItem("app_promotion_goal");
        switch (appPromotionGoal) {
          case "APP_INSTALL":
            switch (goal) {
              case "APP_INSTALLS":
                availableTypes = [
                  "Single Image or Video",
                  "Story Ad",
                  "Collection Ad",
                  "AR Ads",
                ];
                break;
              case "APP_PURCHASE":
              case "SWIPES":
              case "IMPRESSIONS":
              case "APP_REENGAGE_PURCHASE":
                availableTypes = [
                  "Single Image or Video",
                  "Story Ad",
                  "Collection Ad",
                ];
            }
            break;
          case "APP_REENGAGE_PURCHASE":
            availableTypes = [
              "Single Image or Video",
              "Story Ad",
              "Collection Ad",
            ];
            break;
        }
      }

      if (objective === "Sales") {
        switch (direction) {
          case "WEB":
            switch (goal) {
              case "SWIPES":
              case "LANDING_PAGE_VIEW":
                availableTypes = [
                  "Single Image or Video",
                  "Story Ad",
                  "Collection Ad",
                ];
                break;
              case "STORY_OPENS":
                availableTypes = ["Story Ad"];
                break;
            }
            break;
          case "APP":
            switch (goal) {
              case "APP_INSTALLS":
                availableTypes = [
                  "Single Image or Video",
                  "Story Ad",
                  "Collection Ad",
                ];
                break;
              case "SWIPES":
              case "APP_REENGAGE_PURCHASE":
              case "IMPRESSIONS":
                availableTypes = [
                  "Single Image or Video",
                  "Story Ad",
                  "Collection Ad",
                ];
                break;
            }
            break;
        }
      }

      if (availableTypes.includes("Single Image or Video")) {
        this.tab = 1;
        localStorage.setItem("creative_type", "Single Image or Video");
      } else if (availableTypes.includes("Story Ad")) {
        this.tab = 2;
        localStorage.setItem("creative_type", "Story Ad");
      } else if (availableTypes.includes("Collection Ad")) {
        this.tab = 3;
        localStorage.setItem("creative_type", "Collection Ad");
      } else if (availableTypes.includes("AR Ads")) {
        localStorage.setItem("creative_type", "AR Ads");
        this.tab = 4;
      }
      localStorage.setItem("available_types", availableTypes);
      return availableTypes;
    },
  },
};
</script>

<style>
.media-card {
  background: unset !important;
  box-shadow: unset !important;
}

.media-card .v-tabs,
.media-card .v-tabs .v-slide-group__container .v-slide-group__content button {
  height: auto !important;
  margin-inline-start: unset !important;
}

.media-card .v-tabs .v-slide-group__container .v-slide-group__content button,
.media-card
  .v-tabs
  .v-slide-group__container
  .v-slide-group__content
  button:hover {
  color: rgb(84, 85, 87);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  border-top: none;
  border-right: none;
  border-left: none;
  border-image: initial;
  margin-right: 0px;
  bottom: 0px;
  cursor: pointer;
  list-style: none;
  border-bottom: 2px solid transparent;
  -webkit-box-flex: 1;
  opacity: 1;
  padding: 8px 24px;
  background: rgb(225, 227, 229);
  flex: 1 1 0px;
  margin: 0px;
}

.media-card
  .v-tabs
  .v-slide-group__container
  .v-slide-group__content
  button.v-tab--selected {
  background-color: white;
}

.media-card .v-btn:hover > .v-btn__overlay {
  opacity: 0 !important;
}

.media-card .tab-container .img img {
  margin: auto;
  max-height: 80px;
  width: 100%;
}

.media-card .tab-container .name {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  border-image: initial;
  margin-right: 0px;
  bottom: 0px;
  cursor: pointer;
  list-style: none;
  -webkit-box-flex: 1;
  padding: 0px;
  flex: 1 1 0px;
  color: rgb(68, 69, 70);
  opacity: 1;
  position: relative;
  text-transform: capitalize;
}

.media-card .v-tab__slider {
  top: 0px;
  bottom: unset;
  background-color: yellow !important;
  color: green !important;
}

.media-card .v-btn:focus-visible > .v-btn__overlay {
  opacity: 0 !important;
}

.new-ads {
  background-color: black;
  padding: 5px 15px;
  border-radius: 15px;
  color: white;
  text-decoration: none;
}
</style>
